module.exports = __webpack_public_path__ + "static/img/scrapping.7e169cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/scrapping.svg
// module id = 2CfF
// module chunks = 1